import { PolymerAxios } from "./axios"
import { API_DownloadFile } from "./api";
import he from "he";
// https://polymer.hdb.decision-science.agency/transfer-api/polymer/application/downloadFile?key=polymer/c1e6665b-11e9-4c90-9535-4984594ba694/files/Code_Table.pdf
// https://polymer.hdb.decision-science.agency/transfer-api/polymer/application/downloadFile?key=polymer/c1e6665b-11e9-4c90-9535-4984594ba694/legal/_biome_screenshot91071673-1f85-4dc4-8c55-f3566cdf561d.jpg
const base64ToBlob = (base64: any, mime: any) => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mime });
}

const fetchDataUrl = (url: string) => {
  const [prefix, base64Data] = url.split(';base64,');
  if (prefix.startsWith('data:')) {
    const mimeType = prefix.split(':')[1];
    const blob = base64ToBlob(base64Data, mimeType);
    
    // Do something with the blob, for example, create an object URL and display the image
    const objectURL = URL.createObjectURL(blob);
    setTimeout(() => window.open(objectURL, '_blank'))
  } else {
    console.error('Invalid data URL:', url);
  }
}

export const downloadFile = (key: string, singpassToken: string = "", callBack?: () => void) => {


  const extension_type = key.split('.')[1];
  let type = "application/pdf"; //default to be pdf;
  if (extension_type !== "pdf") {
    type = `image/${extension_type}`;
  }


  //CHANGE TO POST on OCT 3rd, Local swagger Docs showing GET.
  //CHANGE query param from `key` to `file` on OCT 3rd.
  PolymerAxios("", singpassToken).post(`${API_DownloadFile}?file=${encodeURIComponent(he.decode(key))}`, {}).then(res => {
    try {
      //NOTE: data is base 64 string return from api
      const { data } = res.data;
      const url = `data:${type};base64,${data}`;

      fetchDataUrl(url);
    }
    catch (e) {
      alert("Oops, problem downloading the file");
    }
  }).catch(e => {
    console.log("get download file catch", e);
    alert("Oops, problem downloading the file");
  }).finally(() => {
    if (callBack) {
      callBack();
    }
  })

}


